var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCellMerge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    viewBox: "0 -960 960 960",
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#029AA9",
    d: "M130.001-130.001v-219.998h59.998v160h160v59.998H130.001Zm480 0v-59.998h160v-160h59.998v219.998H610.001ZM287-341.232 244.232-383l67.001-67.001H90.001v-59.998h221.232L244.232-577 287-618.768 425.768-480 287-341.232Zm386 0L534.232-480 673-618.768 715.768-577l-67.001 67.001h221.232v59.998H648.767L715.768-383 673-341.232ZM130.001-610.001v-219.998h219.998v59.998h-160v160h-59.998Zm640 0v-160h-160v-59.998h219.998v219.998h-59.998Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCellMerge);
export default __webpack_public_path__ + "static/media/cell_merge.42bcb97cc5ce6fd98bbd1a1656627367.svg";
export { ForwardRef as ReactComponent };